/**
 * Created By Elia Rohana on 3/20/19
 */
export class EmptyBendpointMove {
    public start(...args) {
    }
}
